var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Arrow_alt_lright_alt"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 9",
    d: "M18 12.6953L18.3536 12.3418L18.7071 12.6953L18.3536 13.0489L18 12.6953ZM6 13.1953C5.72386 13.1953 5.5 12.9715 5.5 12.6953C5.5 12.4192 5.72386 12.1953 6 12.1953V13.1953ZM14.3536 8.34176L18.3536 12.3418L17.6464 13.0489L13.6464 9.04887L14.3536 8.34176ZM18.3536 13.0489L14.3536 17.0489L13.6464 16.3418L17.6464 12.3418L18.3536 13.0489ZM18 13.1953H6V12.1953H18V13.1953Z",
    fill: "#263238"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/Arrow-right.e8c83585cb78b54d8cbf28bcbdcfe5a7.svg";
export { ForwardRef as ReactComponent };